import ActivityStore from './ActivityStore'
import CompanyStore from './CompanyStore'
import CourseStore from './CourseStore'
import CommonStore from './CommonStore'
import DecorationStore from './DecorationStore'
import FileServerStore from './FileServerStore'
import HomeMesStore from './HomeMesStore'
import MESManufacturerStore from './MESManufacturerStore'
import MESOrderStore from './MESOrderStore'
import NewsStore from './NewsStore'
import PhoneStore from './PhoneStore'
import UserCaseStore from './UserCaseStore'
import UserStore from './UserStore'
import WholeHouseQuoteStore from './WholeHouseQuoteStore'
import ClosetHighwayStore from './ClosetHighwayStore'
import AssemblyStore from './AssemblyStore'
import SalesStore from './SalesStore'
import OfficeStore from './OfficeStore'
import business from './business'
import CaseStore from './CaseStore'
import MesReminderStore from './MesReminderStore'
import ClosingAccountStore from './ClosingAccountStore'
import Produce from './Produce'
import DesignReserve from './DesignReserve'
import OrderPaymentInfoStore from './OrderPaymentInfoStore'
import ClientMonthlyBillStore from './ClientMonthlyBillStore'
import CabinetManageStore from './CabinetManageStore'
import MesFront from './MesFront'

export default {
  ActivityStore,
  CompanyStore,
  CourseStore,
  CommonStore,
  DecorationStore,
  HomeMesStore,
  MESOrderStore,
  MESManufacturerStore,
  NewsStore,
  PhoneStore,
  UserStore,
  UserCaseStore,
  WholeHouseQuoteStore,
  ClosetHighwayStore,
  AssemblyStore,
  SalesStore,
  OfficeStore,
  business,
  CaseStore,
  MesReminderStore,
  ClosingAccountStore,
  Produce,
  DesignReserve,
  FileServerStore,
  OrderPaymentInfoStore,
  ClientMonthlyBillStore,
  CabinetManageStore,
  MesFront
}
